<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader>
        Api's
        <CButton size="sm" style="float:right;" color="success" @click="modal = true">Add Api</CButton>
      </CCardHeader>
      <CCardBody>
        <CDataTable
          :items="items"
          :fields="fields"
          :items-per-page="10"
          pagination
          table-filter
        >
          <template #remove="{item}">
            <td>
              <CButton size="sm" color="danger" @click="remove(item)">Remove</CButton>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
    <CModal
        title="Add API"
        :show.sync="modal"
      >
        <CForm>
          <CInput
            :lazy="false"
            v-model="name"
            placeholder="API Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
        </CForm>
        <template #footer>
          <CButton @click="modal = false, name = ''" color="danger">Cancel</CButton>
          <CButton @click="submitApi()" color="success">Submit</CButton>
        </template>
    </CModal>
  </div>
</template>
<script>
var methods = {}

methods.getApis = function () {
  axios.get(this.$apiAdress + '/api/getApis?token=' + localStorage.getItem('api_token')).then(response => {
    console.log(response)
    this.items = response.data
  })
}

methods.submitApi = function () {
  const postData = {
    name: this.name
  }
  axios.post(this.$apiAdress + '/api/submitApi?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.items.push(response.data)
    this.name = ''
    this.modal = false
  })
}

methods.remove = function (item) {
  const postData = {
    item: item
  }
  axios.post(this.$apiAdress + '/api/removeApi?token=' + localStorage.getItem('api_token'), postData).then(response => {
    this.getApis()
  })
}

export default {
  // ===Component name
  name: "CreateAPI",
  // ===Props passed to component
  props: {},
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        items: null,
        modal: false,
        fields: ['remove', 'name', 'token'],
        name: ''
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getApis()
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
